import { Button, Typography } from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import { IButtonProps } from "../Components";

const SecondaryButton = ({
  onClick,
  title,
  viewStyle,
  rightIcon,
  size = "medium",
}: IButtonProps) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      size={size}
      sx={{ ...styles.button, ...viewStyle }}
      endIcon={rightIcon ? rightIcon : null}
    >
      <Typography sx={styles.buttonTextStyle}>{title}</Typography>
    </Button>
  );
};
export default SecondaryButton;
const styles = {
  button: {
    width: "fit-content",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "1em",
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0.25)",
    px: 2,
    py: 1,
  },
  buttonTextStyle: {
    fontSize: responsiveFontSize(16),
    fontWeight: 400,
    color: theme.palette.primary.main,
    textTransform: "none",
  },
};
